module.exports = ".async-content{position:relative;min-height:40px}.async-content .preloader-container{position:absolute;left:0;right:0;top:0;bottom:0;color:white}.async-content .background{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/async-content/async-content.component.scss
// module id = 630
// module chunks = 0